"use client";
import axios from "@/utils/axiosInterceptor";

const ctrl = {};

ctrl.getEsSolvente = async (cedula, captchaToken) => {
  return axios.get("/api/solvencia/esSolvente", {
    params: {
      cedula,
    },
    headers: {
      "X-Altcha-Token": captchaToken || "",
    },
  });
};

ctrl.getCearSolvencia = async (idpersona) => {
  return axios.get("/api/solvencia/crearSolvencia", {
    params: {
      idpersona,
    },
  });
};

export default ctrl;